module.exports = __webpack_public_path__ + "img/models.4e4dafd3.png";